export const CUSTOM_CATEGORY = 'Свои';

export interface FibbageItem {
    question: string;
    answer: string;
    category?: string;
    custom?: boolean;
    ai?: boolean;
}
